import { MoonStar, Sun } from 'lucide-react';
import { Button } from './ui/button';
import { useTheme } from './theme-provider';

export const ModeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="rounded-full border border-transparent text-slate-600 hover:border-slate-200 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-800"
      aria-label="Farbmodus umschalten"
    >
      {theme === 'dark' ? <Sun className="h-4 w-4" /> : <MoonStar className="h-4 w-4" />}
    </Button>
  );
};
